/**
 * GÖVDENİN HER ALANI BİR KANALA BAĞLIDIR (tech-lead tur 30 · md. 1a).
 *
 * `satisfies Record<keyof CreateEventInput, …>`: sözleşmeye yeni bir alan
 * eklenirse bu dosya DERLENMEZ; eşitleme o alanı sessizce unutamaz.
 * `notCollected` = sihirbaz toplamıyor; `event-draft-sync.spec` sihirbazın
 * gövdesinde böyle bir alan belirirse KIRILIR (iki ayak).
 */
const INPUT_CHANNEL = {
    title: 'patch',
    summary: 'patch',
    description: 'patch',
    format: 'patch',
    startsAt: 'patch',
    endsAt: 'patch',
    timezone: 'patch',
    onlineUrl: 'patch',
    capacity: 'patch',
    tagIds: 'patch',
    venue: 'patch',
    accessMode: 'accessMode',
    tickets: 'tickets',
    organizationId: 'locked',
    coverMediaId: 'patch', // B-12: sihirbaz kapağı topluyor (isteğe bağlı).
    brandLogoMediaId: 'notCollected',
    brandColor: 'notCollected',
    websiteUrl: 'notCollected',
};
export function inputChannelOf(key) {
    return INPUT_CHANNEL[key];
}
/** Kanala göre alanlar (kapı öz testi ve kesit hesabı buradan okur). */
export function inputKeysOf(channel) {
    return Object.keys(INPUT_CHANNEL).filter((key) => INPUT_CHANNEL[key] === channel);
}
const PATCH_KEYS = Object.keys(INPUT_CHANNEL).filter((key) => INPUT_CHANNEL[key] === 'patch');
/** Yama başarıyla yazıldığında `savedInput`a işlenecek künye kesiti (yalnız yama alanları). */
export function patchSlice(input) {
    return Object.fromEntries(PATCH_KEYS.map((key) => [key, input[key]]));
}
const same = (a, b) => JSON.stringify(a) === JSON.stringify(b);
/**
 * Oluşturma gövdesindeki `venue` boş gelirse sunucu üç alanı `null` yazar.
 *
 * KONUM YALNIZ TASLAK TAŞIYORSA KARŞILAŞTIRILIR (harita Story 4): konumu
 * toplamayan istemcinin gövdesinde `geo` anahtarı yoktur; fark hesabına girerse
 * her eşitleme sunucudaki konumu silmeye çalışırdı.
 */
function venueTriple(input) {
    return {
        name: input.venue?.name ?? null,
        addressLine: input.venue?.addressLine ?? null,
        cityCode: input.venue?.cityCode ?? null,
        ...(carriesGeo(input) ? { geo: input.venue?.geo ?? null } : {}),
    };
}
function carriesGeo(input) {
    return input.venue !== undefined && input.venue.geo !== undefined;
}
/**
 * @param saved   sunucuya YAZILDIĞI BİLİNEN gövde. `null` = bilinmiyor, her parça gider.
 * @param unsettled isteği atılmış ama sonucu alınamamış parçalar (hata / zaman aşımı).
 *   Sunucunun o parçadaki hâli BİLİNMEZ: `saved` ile `next` eşit görünse bile
 *   parça yeniden yazılır. Aksi hâlde kullanıcı değeri geri aldığında fark "yok"
 *   çıkar ve sunucu yarıda kalan değerle yayınlanır (tech-lead tur 30).
 */
export function draftSyncPlan(saved, next, 
/** Sunucudaki künyenin mekânı: yama alt nesneyi TAM gönderir (`UpdateEventPatch`). */
currentVenue, unsettled = []) {
    const force = (part) => saved === null || unsettled.includes(part);
    const changed = (a, b) => force('patch') || !same(a, b);
    const patch = {};
    for (const key of PATCH_KEYS) {
        if (key === 'venue' || key === 'tagIds')
            continue;
        // Boş bırakılan alan `null` gider: form sunucunun tek kaynağıdır, sunucu alanı SİLER.
        if (changed(saved?.[key] ?? null, next[key] ?? null)) {
            Object.assign(patch, { [key]: next[key] ?? null });
        }
    }
    if (changed(saved?.tagIds, next.tagIds))
        patch.tagIds = next.tagIds;
    const venue = venueTriple(next);
    if (changed(saved === null ? null : venueTriple(saved), venue)) {
        patch.venue = {
            countryCode: currentVenue?.countryCode ?? null,
            // Formun seçtiği konum; form konum taşımıyorsa sunucudaki korunur.
            geo: carriesGeo(next) ? (next.venue?.geo ?? null) : (currentVenue?.geo ?? null),
            name: venue.name ?? null,
            addressLine: venue.addressLine ?? null,
            cityCode: venue.cityCode ?? null,
        };
    }
    const nextCapacity = next.capacity ?? null;
    const savedCapacity = saved?.capacity ?? null;
    return {
        patch: Object.keys(patch).length > 0 ? patch : null,
        accessMode: force('accessMode') || saved?.accessMode !== next.accessMode ? next.accessMode : null,
        tickets: force('tickets') || !same(saved?.tickets ?? [], next.tickets ?? []),
        ticketsFirst: nextCapacity !== null && (savedCapacity === null || nextCapacity < savedCapacity),
    };
}
export function draftSyncIsEmpty(plan) {
    return plan.patch === null && plan.accessMode === null && !plan.tickets;
}
/** Kontenjanı artıran (ya da sınırsızdan sayıya inen, kuralı AÇAN) güncelleme mi. */
function raisesQuota(from, to) {
    if (to === null)
        return false;
    return from === null || to > from;
}
/**
 * BİLET SATIRLARI → SIRALI İSTEK LİSTESİ (saf; saga yalnız yürütür).
 *
 * EŞLEME SIRAYLA: sunucu türleri `sortOrder`, sonra oluşturma zamanıyla döner
 * ve sihirbazın satırları gövde sırasıyla yazıldı. Ortadaki satır silinirse
 * SON tür silinir, aradakiler bir kaydırılarak güncellenir. Son durum formla
 * birebirdir; tür KİMLİĞİ korunmaz. Taslakta kimliğe bağlı veri yoktur (kayıt
 * yok, `reservedCount` 0), o yüzden kimlik değil içerik eşlenir.
 *
 * SIRA TOPLAM KURALINA GÖRE (tech-lead tur 30): sunucu HER ara adımda
 * kontenjan TOPLAMININ kapasiteyi aşmadığını denetler (`ticketQuotaOverflow`).
 * Önce silme, sonra düşüren/eşit güncelleme, sonra artıran güncelleme, en son
 * ekleme: toplam önce yalnız düşer, sonra yalnız son değere doğru yükselir.
 * Başlangıç ve son hâl geçerliyse her ara hâl de geçerlidir. Satır sırasıyla
 * yürütülseydi `[50,50] → [70,10]` (kapasite 100) ilk adımda 120'ye çıkıp 409
 * alırdı.
 */
export function ticketSyncSteps(server, wanted) {
    const removes = [];
    const lowers = [];
    const raises = [];
    const creates = [];
    for (const [index, ticket] of server.entries()) {
        if (index >= wanted.length)
            removes.push({ op: 'remove', ticketId: ticket.id });
    }
    for (const [index, row] of wanted.entries()) {
        const quota = row.quota ?? null;
        const ticket = server[index];
        if (!ticket) {
            creates.push({ op: 'create', input: { kind: row.kind, quota, sortOrder: index } });
            continue;
        }
        const current = ticket.quota ?? null;
        if (ticket.kind === row.kind && current === quota)
            continue;
        const step = {
            op: 'update',
            ticketId: ticket.id,
            input: { kind: row.kind, quota },
        };
        (raisesQuota(current, quota) ? raises : lowers).push(step);
    }
    return [...removes.reverse(), ...lowers, ...raises, ...creates];
}
//# sourceMappingURL=event-draft-sync.js.map